import * as React from 'react'
import * as ReactDOM from 'react-dom/client'
import { HandleReactComponentRendering } from '@ClientBase/React/RenderReactComponents'
import { declareClientPackage, RuntimeDetails } from '@ClientBase/IClientPackage'
import * as Carousels from './Carousels'
import * as Navigation from './Navigation'
import * as SearchOverlay from './SearchOverlay'
import * as Modal from './Modal'
import * as HeroVideo from './HeroVideo'
import * as BannerVideo from './BannerVideo'
import * as Listwidget from './ListWidget'
import * as JobDetails from './Jobs/Details'
import * as JobTile from './Jobs/Tile'
import * as JobFilters from './Jobs/Filters'
import * as PostFilters from './PostFilters'
import * as Pagination from './Pagination'
import * as GeolocationOverlay from './GeolocationOverlay'
import SnippetSpacer from './Spacer/Spacer'
import SnippetHeading from './Heading/Heading'
import SnippetContent from './Content/Content'
import SnippetImageContent from './ImageContent/ImageContent'
import SnippetImageContentCTA from './ImageContentCTA/ImageContentCTA'
import SnippetContentColumn from './ContentColumn/ContentColumn'
import SnippetTeamTile from './TeamTile/TeamTile'
import SnippetLinkBox from './LinkBox/LinkBox'
import SnippetTabSwitcher from './TabSwitcher/TabSwitcher'
import SnippetIconsText from './IconsText/IconsText'
import SnippetAccordionReact from './Accordion/Accordion'
import SnippetVideo from './Video/Video'
import SnippetIntroduction from './Introduction/Introduction'
import SnippetBrandsCarousel from './BrandsCarousel/BrandsCarousel'
import SnippetQuotesCarousel from './QuotesCarousel/QuotesCarousel'
import SnippetImageCardGrid from './ImageCardGrid/ImageCardGrid'
import SnippetContentThumbnail from './ContentThumbnails/ContentThumbnails'
import SnippetContentImageCarousel from './ContentImageCarousel/ContentImageCarousel'
/**
 * Extend the ClientBase class so you can benefit from any event hooks that Attrax offers,
 * and so that Attrax knows you have defined specific methods
 */

const _Components = {
    'SnippetSpacer': SnippetSpacer,
    'SnippetHeading': SnippetHeading,
    'SnippetContent' : SnippetContent,
    'SnippetImageContent': SnippetImageContent,
    'SnippetImageContentCTA': SnippetImageContentCTA,
    'SnippetContentColumn': SnippetContentColumn,
    'SnippetTeamTile': SnippetTeamTile,
    'SnippetLinkBox': SnippetLinkBox,
    'SnippetTabSwitcher': SnippetTabSwitcher,
    'SnippetIconsText' : SnippetIconsText,
    'SnippetAccordion' : SnippetAccordionReact,
    'SnippetVideo' : SnippetVideo,
    'SnippetIntroduction': SnippetIntroduction,
    'SnippetBrandsCarousel': SnippetBrandsCarousel,
    'SnippetQuotesCarousel': SnippetQuotesCarousel,
    'SnippetImageCardGrid': SnippetImageCardGrid,
    'SnippetContentThumbnails': SnippetContentThumbnail,
    'SnippetContentImageCarousel': SnippetContentImageCarousel,
}

declareClientPackage({
    onCmsSnippetPreview() {
        HandleReactComponentRendering(React, ReactDOM, _Components)
    },
    onDocumentReady(details: RuntimeDetails) {
        HandleReactComponentRendering(React, ReactDOM, _Components)
        HeroVideo.initialise()
        Navigation.initialise()
        JobDetails.initialise()
        JobTile.initialise()
        Listwidget.initialise()
        Carousels.initialise()
        JobFilters.initialise()
        PostFilters.initialise()
        Pagination.initialise()
        GeolocationOverlay.initialise()
        Modal.closeModalOnBgClick()
        SearchOverlay.initialise()
        BannerVideo.initialise()
        $(document).on('job-filter-initialized', function () {
            (window as any).jobFilterNoReloadController.enableDefaultFilterCounts()
        })
    }
})
